import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateTimeUtilService {
  /**
   * Combines a date object with a time string to create a new datetime
   * @param date The date object
   * @param timeString Time in format 'HH:mm'
   * @returns A new Date object with combined date and time
   */
  combineDateAndTime(date: Date, timeString: string): Date {
    const [hours, minutes] = timeString.split(':').map(Number);

    const result = new Date(date);
    result.setHours(hours || 0);
    result.setMinutes(minutes || 0);
    result.setSeconds(0);

    return result;
  }

  /**
   * Format a date object to a time string
   * @param date The date object
   * @returns Time string in format 'HH:mm'
   */
  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }
}
